/* eslint react/no-multi-comp: "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Confirm, OptionDropdown, ODataTable, Spinner, Formatter, Modal, Button, PopOver, Highlighter,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import ErroreIcon from 'framework-ui-components/Components/Icons/ErroreIcon';
import InfoIcon from 'framework-ui-components/Components/Icons/InfoIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import CollapseIcon from 'framework-ui-components/Components/Icons/CollapseIcon';
import ExpandIcon from 'framework-ui-components/Components/Icons/ExpandIcon';
import {
  elimina, impostaStatoAnnullata, impostaStatoCompleta, impostaStatoDaControllare, impostaStatoInLavorazione,
  stampaF24, stampaParcelle, stampaUfficiale, stampeVarie, modificaAnagraficheDichiarazione,
  creaDaAnnoPrecedente
} from 'apis/setteTrentaApi';

import TipoDichiarazione from 'enums/TipoDichiarazione';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import { startLoadingApplication, stopLoadingApplication } from 'actions/applicationActions';
import Servizi from 'enums/Servizi';

import ModaleStorico from '../Shared/ModaleStorico';
import { capitalizeFirstLetter } from '../../helpers/stringHelper';
import ModaleCodiceFiscale from './ModaleModifica/ModaleCodiceFiscale';
import ModaleInfoCodiceFiscale from './ModaleModifica/ModaleInfoCodiceFiscale';
import ModaleRiduzioneAcc from './ModaleRiduzioneAcc';
import ModaleModificaSegnalibro from './ModaleModificaSegnalibro';
import checkServizio from '../../helpers/checkServizio';
import CellaNumeroNoteDichiarazione from './RigaDichiarazione/CellaNumeroNoteDichiarazione';

class ModaleAvviso extends Component {
  state = {
    show: true,
  }

  componentDidMount = () => {
    setTimeout(() => { this.refMainButton.refButton.focus(); }, 0);
  }

  close = () => {
    this.setState({ show: false });
  }

  annulla = () => {
    const { reject } = this.props;
    this.close();
    reject();
  }

  conferma = () => {
    const { resolve } = this.props;
    this.close();
    resolve();
  }

  render = () => (
    <Modal show={this.state.show} onClose={this.close} className="confirm confirm--warning">
      <Modal.Header><div className="confirm__icon"><InfoIcon /></div><div className="confirm__title">Attenzione</div></Modal.Header>
      <Modal.Body>La dichiarazione è stata riportata in lavorazione. <br /> Ricordati di ritrasmetterla una volta corretta.</Modal.Body>
      <Modal.Footer>
        <Button ref={r => this.refMainButton = r} onClick={this.conferma} primary flat>Conferma</Button>
      </Modal.Footer>
    </Modal>
  )
}

const Avviso = () => new Promise(((resolve, reject) => {
  const reactElement = (
    <ModaleAvviso
      resolve={resolve}
      reject={reject}
    />
  );
  ReactDOM.render(reactElement, document.createElement('div'));
}));

class RigaDichiarazione extends Component {
  state = {
    mostraStorico: false,
    visualizzaTrasmissioneManuale: false,
    caricando: false,
    mostraModaleModifica: false,
    mostraModaleInfo: false,
    modaleModificaData: null,
    messaggioErroreModifica: null,
    loadingModaleModifica: false,
    modificaSegnalibro: false,
    espanso: false,
  }

  componentDidUpdate(prevProps) {
    if (this.props.item.Id != prevProps.item.Id) {
      this.setState({ espanso: false });
    }
  }

  apriModaleIntegrativa = () => {
    this.props.additionalRowData && this.props.additionalRowData.onApriModaleIntegrativa && this.props.additionalRowData.onApriModaleIntegrativa(this.props.item);
  }

  creaDaAnnoPrecedente = (item) => {
    this.props.startLoadingApplication();
    creaDaAnnoPrecedente(item.CodiceUfficio, item.CodiceFiscale, item.Nome, item.Cognome, TipoDichiarazione.Ordinaria, item.Anno, item.DatiAddizionali.Origine).then((res) => {
      if (res.Success) {
        // var url = this.props.anniRegistrati.filter(x => x.Anno == this.props.annoSelezionato)[0].Url730;
        // window.location.href = url + "#/Frontespizio/" + res.IdDichiarazione.split('/')[1];
      } else {
        SnackbarManager.notifyError(res.DetectedProblems);
      }
    });
  }

  modifica = () => {
    const {
      anniRegistrati, annoSelezionato, servizioAttivo, item,
    } = this.props;

    let visualizza = '';
    if (servizioAttivo == false) {
      visualizza = 'Visualizza/';
    }

    const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;
    if (item.Tipo == TipoDichiarazione.SetteTrentaIntegrativaCodice2) {
      window.location.href = `${url}#/SostitutoImposta/${visualizza}${item.IdDichiarazione.split('/')[1]}`;
    } else {
      window.location.href = `${url}#/Frontespizio/${visualizza}${item.IdDichiarazione.split('/')[1]}`;
    }
  }

  elimina = () => {
    if (this.props.item.DatiAddizionali.Tipologia == 'Co') {
      Confirm('Conferma', `Verrà eliminata anche la dichiarazione di ${this.props.item.DatiAddizionali.Coniuge} in quanto risulta congiunta. Se desideri eliminarne solo una, prima devi separare le dichiarazioni.`, 'warning', 'Elimina entrambe').then((x) => {
        elimina(this.props.item.IdDichiarazione, this.props.annoSelezionato).then((x) => {
          if (!x.Success) {
            x.DetectedProblems.unshift("Errore durante l'eliminazione della dichiarazione.");
            SnackbarManager.notifyError(x.DetectedProblems);
          }
        });
      });
    } else {
      Confirm('Conferma', `Sei sicuro di voler eliminare la dichiarazione di ${this.props.item.Dichiarante}?`, 'warning').then((x) => {
        elimina(this.props.item.IdDichiarazione, this.props.annoSelezionato).then((x) => {
          if (!x.Success) {
            x.DetectedProblems.unshift("Errore durante l'eliminazione della dichiarazione.");
            SnackbarManager.notifyError(x.DetectedProblems);
          }
        });
      });
    }
  }

  stampeVarie = () => {
    stampeVarie(this.props.item.IdDichiarazione).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante elaborazione stampe varie.');
        SnackbarManager.notifyError(x.DetectedProblems);
      }
    });
  }

  stampaUfficiale = () => {
    stampaUfficiale(this.props.item.IdDichiarazione).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante elaborazione stampa ufficiale');
        SnackbarManager.notifyError(x.DetectedProblems);
      }
    });
  }

  stampaF24 = () => {
    stampaF24(this.props.item.IdDichiarazione).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante elaborazione stampa F24');
        SnackbarManager.notifyError(x.DetectedProblems);
      }
    });
  }

  stampaParcelle = () => {
    stampaParcelle(this.props.item.IdDichiarazione).then((x) => {
      if (!x.Success) {
        x.DetectedProblems.unshift('Errore durante elaborazione stampa parcelle');
        SnackbarManager.notifyError(x.DetectedProblems);
      }
    });
  }

  apriModaleStorico = () => {
    this.setState({ mostraStorico: true });
  }

  chiudiModaleStorico = () => {
    this.setState({ mostraStorico: false });
  }

  apriModaleModificaCodiceFiscale = () => {
    const data = {
      IdAnagraficaDichiarante: this.props.item.DatiAddizionali.IdAnagraficaDichiarante,
      CodiceFiscaleDichiarante: this.props.item.CodiceFiscale,
      CognomeDichiarante: this.props.item.Cognome,
      NomeDichiarante: this.props.item.Nome,
      IdAnagraficaConiuge: this.props.item.DatiAddizionali.IdAnagraficaConiuge,
      CodiceFiscaleConiuge: this.props.item.DatiAddizionali.CodiceFiscaleConiuge,
      DenominazioneConiuge: this.props.item.DatiAddizionali.Coniuge,
    };
    this.setState({ mostraModaleModifica: true, modaleModificaData: data });
  }

  chiudiModaleModifica = () => {
    this.setState({ mostraModaleModifica: false, modaleModificaData: null });
  }

  apriModaleInfoCodiceFiscale = () => {
    const data = {
      IdAnagraficaDichiarante: this.props.item.DatiAddizionali.IdAnagraficaDichiarante,
      CodiceFiscaleDichiarante: this.props.item.CodiceFiscale,
      CognomeDichiarante: this.props.item.Cognome,
      NomeDichiarante: this.props.item.Nome,
      IdAnagraficaConiuge: this.props.item.DatiAddizionali.IdAnagraficaConiuge,
      CodiceFiscaleConiuge: this.props.item.DatiAddizionali.CodiceFiscaleConiuge,
      DenominazioneConiuge: this.props.item.DatiAddizionali.Coniuge,
    };
    this.setState({ mostraModaleInfo: true, modaleModificaData: data });
  }

  apriModaleRiduzioneAcc = () => {
    this.setState({ mostraModaleRiduzioneAcc: true });
  }

  chiudiModaleInfo = () => {
    this.setState({ mostraModaleInfo: false });
  }

  chiudiModaleRiduzioneAcc = () => {
    this.setState({ mostraModaleRiduzioneAcc: false });
  }

  // #region Stati

  controllaESettaCompleta = () => {
    this.settaCompleta();
  }

  settaCompleta = () => {
    Confirm('Cambio stato', 'Portare la dichiarazione in Completa?', 'warning')
      .then((x) => {
        this.props.startLoadingApplication();
        impostaStatoCompleta(this.props.item.IdDichiarazione, this.props.annoSelezionato)
          .then((x) => {
            if (!x.Success) {
              x.DetectedProblems.unshift('Errore durante il completamento della dichiarazione');
              SnackbarManager.notifyError(x.DetectedProblems);
              this.props.stopLoadingApplication();
            }
          });
      });
  }

  controllaESettaDaControllare = () => {
    this.settaDaControllare();
  }

  settaDaControllare = () => {
    Confirm('Cambio stato', 'Portare la dichiarazione in Trasmessa a CGN?', 'warning')
      .then((x) => {
        this.props.startLoadingApplication();
        impostaStatoDaControllare(this.props.item.IdDichiarazione, this.props.annoSelezionato)
          .then((x) => {
            if (!x.Success) {
              x.DetectedProblems.unshift('Errore durante impostazione stato Da Inviare');
              SnackbarManager.notifyError(x.DetectedProblems);
              this.props.stopLoadingApplication();
            }
          });
      });
  }

  settaInLavorazione = () => {
    Confirm('Cambio stato', 'Portare la dichiarazione In Lavorazione?', 'warning')
      .then((x) => {
        this.props.startLoadingApplication();
        impostaStatoInLavorazione(this.props.item.IdDichiarazione, this.props.annoSelezionato)
          .then((x) => {
            if (!x.Success) {
              x.DetectedProblems.unshift('Errore durante impostazione stato In Lavorazione');
              SnackbarManager.notifyError(x.DetectedProblems);
              this.props.stopLoadingApplication();
            }
          });
      });
  }

  settaAnnullata = () => {
    Confirm('Cambio stato', 'Annullare la dichiarazione?', 'warning')
      .then((x) => {
        this.props.startLoadingApplication();
        impostaStatoAnnullata(this.props.item.IdDichiarazione, this.props.annoSelezionato)
          .then((x) => {
            if (!x.Success) {
              x.DetectedProblems.unshift('Errore durante impostazione stato Annullata');
              SnackbarManager.notifyError(x.DetectedProblems);
              this.props.stopLoadingApplication();
            }
          });
      });
  }

  // #endregion

  visualizzaDichiarazione = () => {
    const { anniRegistrati, annoSelezionato, item } = this.props;

    if (item.Stato == StatoDichiarazione.Importabile) {
      this.creaDaAnnoPrecedente(item);
    } else if (item.Stato == StatoDichiarazione.InLavorazione || (item.Stato == StatoDichiarazione.InLavorazione && item.HaErrori)
      || item.Stato == StatoDichiarazione.AnnoPrecedente || item.Stato == StatoDichiarazione.ScartataPrecompilato) {
      this.modifica();
    } else if (item.Stato == StatoDichiarazione.ScartataCF) {
      this.apriModaleInfoCodiceFiscale();
    } else {
      const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;
      if (item.Tipo == TipoDichiarazione.SetteTrentaIntegrativaCodice2) {
        window.location.href = `${url}#/SostitutoImposta/Visualizza/${item.IdDichiarazione.split('/')[1]}`;
      } else {
        window.location.href = `${url}#/Frontespizio/Visualizza/${item.IdDichiarazione.split('/')[1]}`;
      }
    }
  }

  trasmettiManualmente = () => {
    trasmettiManualmente(this.props.item.IdDichiarazione)
      .then((x) => {
        if (x.Success) {
          SnackbarManager.notifySuccess('Dichiarazione avanzata a Trasmessa');
        } else {
          SnackbarManager.notifyError(x.DetectedProblems);
        }
      });
  }

  modificaCodiceFiscale = (data) => {
    const cmd = {
      CodiceUfficio: this.props.item.CodiceUfficio,
      IdAnagraficaDichiarante: data.dichiaranteErrato ? data.IdAnagraficaDichiarante : null,
      CodiceFiscaleDichiarante: data.dichiaranteErrato ? data.NuovoCodiceFiscaleDichiarante : null,
      CognomeDichiarante: data.dichiaranteErrato ? data.NuovoCognomeDichiarante : null,
      NomeDichiarante: data.dichiaranteErrato ? data.NuovoNomeDichiarante : null,
      IdAnagraficaConiuge: data.coniugeErrato ? data.IdAnagraficaConiuge : null,
      CodiceFiscaleConiuge: data.coniugeErrato ? data.NuovoCodiceFiscaleConiuge : null,
      CognomeConiuge: data.coniugeErrato ? data.NuovoCognomeConiuge : null,
      NomeConiuge: data.coniugeErrato ? data.NuovoNomeConiuge : null,
      Anno: this.props.annoSelezionato,
    };

    if (cmd.IdAnagraficaConiuge || cmd.IdAnagraficaDichiarante) {
      this.setState({ loadingModaleModifica: true }, () => {
        modificaAnagraficheDichiarazione(cmd)
          .then((res) => {
            if (res.Success) {
              setTimeout(() => { // rallento l'esecuzione dei comandi per evitare concorrenza nell'aggiornamento di anagrafiche
                impostaStatoInLavorazione(this.props.item.IdDichiarazione, this.props.annoSelezionato)
                  .then((x) => {
                    if (!x.Success) {
                      x.DetectedProblems.unshift('Errore durante impostazione stato In Lavorazione');
                      SnackbarManager.notifyError(x.DetectedProblems);
                    } else {
                      Avviso();
                    }
                  });
              }, 400);
              this.setState({ loadingModaleModifica: false, messaggioErroreModifica: null, mostraModaleModifica: false });
            } else {
              this.setState({ loadingModaleModifica: false, messaggioErroreModifica: res.DetectedProblems });
            }
          });
      });
    }
  }

  //  crea / modifica ANF
  urlAssegnoNucleoFamiliare(idDichiarazione, modifica = false) {
    const { anniRegistrati, annoSelezionato } = this.props;
    const url = anniRegistrati.find(x => x.Anno == annoSelezionato).UrlANF;
    const [id] = idDichiarazione.match(/\d+(\-[A-Z])?/);
    return `${url}#/Frontespizio/${!modifica ? 'Visualizza/' : ''}${id}`;
  }

  apriDichiarazione(id, modifica) {
    window.open(this.urlAssegnoNucleoFamiliare(id, modifica), '_blank');
    return Promise.resolve();
  }

  scaricaRicevutaAdE = () => {
    const { additionalRowData: { scaricaRicevutaAdE }, item } = this.props;
    scaricaRicevutaAdE && scaricaRicevutaAdE(item);
  }

  render() {
    const {
      additionalRowData, item, annoSelezionato, anniRegistrati,
    } = this.props;
    const datiAggiuntivi = item.DatiAddizionali || {};
    const {
      caricando, mostraStorico,
      mostraModaleModifica, modaleModificaData, messaggioErroreModifica, loadingModaleModifica,
      mostraModaleInfo, mostraModaleRiduzioneAcc, espanso, modificaSegnalibro,
    } = this.state;

    const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;

    return (
      <tr key={item.IdDichiarazione}>
        <td>{(item.Stato != StatoDichiarazione.Importabile || annoSelezionato > 2019) && <ODataTable.SelectCheckBox {...this.props} />}</td>
        <td onClick={this.visualizzaDichiarazione}>
          <Highlighter text={item.Dichiarante} value={additionalRowData.searchTerm} />
          {espanso && <span><br /><Highlighter text={item.CodiceFiscale} value={additionalRowData.searchTerm} /></span>}
        </td>
        <td onClick={this.visualizzaDichiarazione}>
          <Highlighter text={datiAggiuntivi && datiAggiuntivi.Coniuge} value={additionalRowData.searchTerm} />
          {espanso && <span><br /><Highlighter text={datiAggiuntivi && datiAggiuntivi.CodiceFiscaleConiuge && datiAggiuntivi.CodiceFiscaleConiuge.toUpperCase()} value={additionalRowData.searchTerm} /></span>}
        </td>
        <td onClick={this.visualizzaDichiarazione}>
          {datiAggiuntivi && datiAggiuntivi.Tipologia && capitalizeFirstLetter(datiAggiuntivi.Tipologia)}
        </td>
        <td onClick={this.visualizzaDichiarazione}>
          <Highlighter text={datiAggiuntivi && datiAggiuntivi.DenominazioneSostitutoImposta && datiAggiuntivi.DenominazioneSostitutoImposta.toUpperCase()} value={additionalRowData.searchTerm} />
        </td>
        <td onClick={this.visualizzaDichiarazione}>
          {StatoDichiarazione.stringify(item.Stato, item.HaErrori)}
        </td>

        <td onClick={this.visualizzaDichiarazione}>
          {TipoDichiarazione.stringify(item.Tipo)}
        </td>
        <td onClick={this.visualizzaDichiarazione}>
          {item.Segnalibro}
        </td>

        {
          (additionalRowData.tabNr == 3 || additionalRowData.tabNr == 0)
          && (
            <td onClick={this.visualizzaDichiarazione} className="text--center">
              {((item.Stato == StatoDichiarazione.DaInviare
                || item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente
                || item.Stato == StatoDichiarazione.DaTrasmettere || item.Stato == StatoDichiarazione.DaAnnullare) && datiAggiuntivi && datiAggiuntivi.StampaUfficialeEffettuata == 'True')
                && <PopOver top content="Stampata"><SuccessoIcon className="icon-success" /></PopOver>}
              {((item.Stato == StatoDichiarazione.DaInviare
                || item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente
                || item.Stato == StatoDichiarazione.DaTrasmettere || item.Stato == StatoDichiarazione.DaAnnullare) && datiAggiuntivi && datiAggiuntivi.StampaUfficialeEffettuata == 'False')
                && <PopOver top content="Da stampare"><ErroreIcon className="icon-alert" /></PopOver>}
              {item.Stato == StatoDichiarazione.DaControllare
                && <PopOver top content="Da controllare"><ErroreIcon className="icon-alert" /></PopOver>}
            </td>
          )
        }

        <td onClick={this.visualizzaDichiarazione}>
          <Formatter tipo="date" valore={item.DataUltimaModifica || item.DataCreazione} />
        </td>
        <CellaNumeroNoteDichiarazione numeroNote={item.NumeroNote} onClick={this.visualizzaDichiarazione} />
        <td>
          {caricando
            ? <Spinner small />
            : (
              <OptionDropdown>
                {false
                  && annoSelezionato > 2019 && item.Stato === StatoDichiarazione.TrasmessaAutomaticamente
                  && <OptionDropdown.Item onClick={this.scaricaRicevutaAdE}>Scarica ricevuta AdE</OptionDropdown.Item>}

                {/* Modifica */}
                {
                  this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.InLavorazione || (item.Stato == StatoDichiarazione.InLavorazione && item.HaErrori)
                    || item.Stato == StatoDichiarazione.AnnoPrecedente || item.Stato == StatoDichiarazione.completa)
                  && <OptionDropdown.Item onClick={this.modifica}>Modifica</OptionDropdown.Item>
                }

                {/* Visualizza */}
                {(this.props.servizioAttivo == false
                  || (item.Stato == StatoDichiarazione.ScartataCF || item.Stato == StatoDichiarazione.ScartataAudit || item.Stato == StatoDichiarazione.Annullata
                    || item.Stato == StatoDichiarazione.ScartataRicalcolo || item.Stato == StatoDichiarazione.ScartataEnte || item.Stato == StatoDichiarazione.BloccataIntegrativa
                    || item.Stato == StatoDichiarazione.AnnullataAE || item.Stato == StatoDichiarazione.DaAnnullare || item.Stato == StatoDichiarazione.TrasmessaAutomaticamente
                    || item.Stato == StatoDichiarazione.DaInviare || item.Stato == StatoDichiarazione.DaTrasmettere || item.Stato == StatoDichiarazione.DaControllare))
                  && <OptionDropdown.Item onClick={() => { window.location.href = url + (this.props.item.Tipo == TipoDichiarazione.SetteTrentaIntegrativaCodice2 ? '#/SostitutoImposta/Visualizza/' : '#/Frontespizio/Visualizza/') + this.props.item.IdDichiarazione.split('/')[1]; }}>Visualizza</OptionDropdown.Item>
                }

                {/* Modifica CF */}
                {this.props.servizioAttivo == true && item.Stato == StatoDichiarazione.ScartataCF
                  && <OptionDropdown.Item onClick={this.apriModaleModificaCodiceFiscale}>Correggi codici fiscali</OptionDropdown.Item>
                }

                {this.props.servizioAttivo == true && <OptionDropdown.Item onClick={() => this.setState({ modificaSegnalibro: true })}>Modifica segnalibro</OptionDropdown.Item>}

                {/* Stampa Riduzione secondo acconto - da riabilitare quando corretto */}

                {
                  this.props.servizioAttivo == true && item.Tipo != TipoDichiarazione.SetteTrentaIntegrativaCodice3 && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.DaTrasmettere || item.Stato == StatoDichiarazione.DaInviare)
                  && <OptionDropdown.Item onClick={() => { this.apriModaleRiduzioneAcc(); }}>Lettera di riduzione/annullamento del secondo acconto</OptionDropdown.Item>
                }

                {/* Crea integrativa */}
                {
                  this.props.servizioAttivo
                  && additionalRowData.impostazioni
                  && additionalRowData.impostazioni.CampagnaIntegrativiAperta
                  && ((item.Tipo === TipoDichiarazione.Ordinaria && [StatoDichiarazione.Completa, StatoDichiarazione.TrasmessaAutomaticamente].includes(item.Stato))
                    || (item.Tipo === TipoDichiarazione.SetteTrentaIntegrativaCodice2 && StatoDichiarazione.TrasmessaAutomaticamente === item.Stato))
                  && <OptionDropdown.Item onClick={this.apriModaleIntegrativa}>Crea integrativa</OptionDropdown.Item>
                }

                {/* Setta come completa */}
                {this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.InLavorazione && !item.HaErrori)
                  && <OptionDropdown.Item onClick={this.controllaESettaCompleta}>Imposta come "Completa"</OptionDropdown.Item>
                }
                {/* Setta come trasmessa cgn */}
                {this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.Completa || item.Stato == StatoDichiarazione.Annullata)
                  && <OptionDropdown.Item onClick={this.controllaESettaDaControllare}>Imposta come "Trasmessa CGN"</OptionDropdown.Item>
                }
                {/* Setta come In Lavorazione */}
                {this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.Completa || item.Stato == StatoDichiarazione.ScartataAudit
                  || item.Stato == StatoDichiarazione.ScartataPrecompilato
                  || item.Stato == StatoDichiarazione.Annullata || item.Stato == StatoDichiarazione.ScartataRicalcolo
                  || item.Stato == StatoDichiarazione.AnnullataAE)

                  && <OptionDropdown.Item onClick={this.settaInLavorazione}>Imposta come "In Lavorazione"</OptionDropdown.Item>

                }
                {/* Setta come Annullata */}
                {this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.DaControllare || item.Stato == StatoDichiarazione.DaInviare)
                  && <OptionDropdown.Item onClick={this.settaAnnullata}>Imposta come "Annullata"</OptionDropdown.Item>
                }
                {/* Storico: sempre presente */}
                <OptionDropdown.Item onClick={this.apriModaleStorico}>Storico</OptionDropdown.Item>
                {/* Elimina */}
                {this.props.servizioAttivo == true && (item.Stato == StatoDichiarazione.InLavorazione || (item.Stato == StatoDichiarazione.InLavorazione && item.HaErrori)
                  || item.Stato == StatoDichiarazione.AnnoPrecedente || item.Stato == StatoDichiarazione.Completa
                  || item.Stato == StatoDichiarazione.Annullata || item.Stato == StatoDichiarazione.AnnullataAE)
                  && <OptionDropdown.Item onClick={this.elimina}>Elimina</OptionDropdown.Item>
                }
              </OptionDropdown>
            )
          }


          {mostraStorico
            && (
              <ModaleStorico
                idDichiarazione={item.Id}
                onClose={this.chiudiModaleStorico}
                denominazione={item.Dichiarante}
              />
            )}

          <ModaleCodiceFiscale
            idDichiarazione={item.IdDichiarazione}
            idDichiarazioneConiuge={datiAggiuntivi.IdDichiarazioneConiuge}
            show={mostraModaleModifica}
            data={modaleModificaData}
            onClose={this.chiudiModaleModifica}
            inLavorazione={this.settaInLavorazione}
            onModifica={this.modificaCodiceFiscale}
            errore={messaggioErroreModifica}
            isLoading={loadingModaleModifica}
            annoSelezionato={annoSelezionato}
          />

          <ModaleInfoCodiceFiscale
            idDichiarazione={item.IdDichiarazione}
            idDichiarazioneConiuge={datiAggiuntivi.IdDichiarazioneConiuge}
            show={mostraModaleInfo}
            data={modaleModificaData}
            onClose={this.chiudiModaleInfo}
            onCorreggi={this.apriModaleModificaCodiceFiscale}
            onRiapri={this.settaInLavorazione}
            onVisualizza={() => window.location.href = `${url}#/Frontespizio/Visualizza/${item.IdDichiarazione.split('/')[1]}`}
            errore={messaggioErroreModifica}
            isLoading={loadingModaleModifica}
            annoSelezionato={annoSelezionato}
          />

          {mostraModaleRiduzioneAcc && (
            <ModaleRiduzioneAcc
              idDichiarazione={item.IdDichiarazione}
              showModal
              onClose={this.chiudiModaleRiduzioneAcc}
              annoSelezionato={this.props.annoSelezionato}
            />
          )
          }

          {modificaSegnalibro && (
            <ModaleModificaSegnalibro
              idDichiarazione={item.Id}
              showModal
              onClose={() => this.setState({ modificaSegnalibro: false })}
              segnalibro={item.Segnalibro}
            />
          )}
        </td>
        <td>
          {espanso ? <Button icon onClick={() => this.setState({ espanso: false })}><CollapseIcon /></Button> : <Button icon onClick={() => this.setState({ espanso: true })}><ExpandIcon /></Button>}
        </td>
      </tr>
    );
  }
}

RigaDichiarazione.propTypes = {
  additionalRowData: PropTypes.object,
  item: PropTypes.object,
  startLoadingApplication: PropTypes.func,
  stopLoadingApplication: PropTypes.func,
};

const mapStoreToProps = store => ({
  annoSelezionato: store.dichiarativi.annoSelezionato,
  anniRegistrati: store.dichiarativi.anniRegistrati.data,
  codiceUfficio: store.utente.ufficioSelezionato.CodiceUfficio,
});

const mapDispatchToProps = dispatch => ({
  startLoadingApplication: bindActionCreators(startLoadingApplication, dispatch),
  stopLoadingApplication: bindActionCreators(stopLoadingApplication, dispatch),
});

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, mapDispatchToProps, null, { pure: false, withRef: true })(RigaDichiarazione));
